import React from 'react'
import { Form } from 'Components/Form'
import { Footer } from 'Components/Footer'


export const App = () => {
  return (
    <main>
      <Form />
      <Footer />
    </main>
   )
}


